import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  inputStyling: {
    fontSize: theme.typography.pxToRem(24),
    [theme.breakpoints.up(700)]: {
      fontSize: theme.typography.pxToRem(40),
    },
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  searchIcon: {
    fontSize: theme.typography.pxToRem(24),
    [theme.breakpoints.up(700)]: {
      fontSize: theme.typography.pxToRem(40),
    },
  },
  clearButton: {
    border: 'none',
    backgroundColor: 'transparent',
  },
  clearIcon: {
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.text.secondary,
    [theme.breakpoints.up(700)]: {
      fontSize: theme.typography.pxToRem(40),
    },
  },
}));
